<template>
  <!-- Exact replica of BSTK's loading spinner, without installing the Ant Design library -->
  <span class="rs-iframe-spin-dot rs-iframe-spin-dot-spin">
    <i class="rs-iframe-spin-dot-item" />
    <i class="rs-iframe-spin-dot-item" />
    <i class="rs-iframe-spin-dot-item" />
    <i class="rs-iframe-spin-dot-item" />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsIFrameSpin',
});
</script>

<style lang="scss">
.rs-iframe-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
  color: #2d41cf;
}

.rs-iframe-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: currentColor;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: rs-spin-dot-fade 1s linear infinite alternate;

  &:nth-child(1) { top: 0;    left: 0;   animation-delay: 0s; }
  &:nth-child(2) { top: 0;    right: 0;  animation-delay: 0.4s; }
  &:nth-child(3) { bottom: 0; right: 0;  animation-delay: 0.8s; }
  &:nth-child(4) { bottom: 0; left: 0;   animation-delay: 1.2s; }
}

.rs-iframe-spin-dot-spin {
  transform: rotate(45deg);
  animation: rs-spin-rotate 1.2s linear infinite;
}

@keyframes rs-spin-rotate {
  to { transform: rotate(405deg); }
}

@keyframes rs-spin-dot-fade {
  to { opacity: 1; }
}
</style>
